export function getContentPlatformUrl(path: string): string {
  return `${import.meta.env.VITE_CONTENT_PLATFORM_BASE_URL}${path}`;
}
